export default "__VITE_ASSET__uIZ0vGNp__"